<template>
  <hvh-content-header variant="analysis" ref="header">
    <template slot="heading">
      <div class="hvh-flex column">
        <cohort-verified-heading class="w-100" :value="cohort.cohortVerified" v-if="cohort.cohortVerified"></cohort-verified-heading>
        <cohort-private-heading class="w-100" v-if="cohort.isPrivate"></cohort-private-heading>
        <cohort-publish-heading class="w-100" :value="cohort.clientsPublishedView"></cohort-publish-heading>
        <div class="hvh-content-header__heading hvh-relative">
          <hvh-icon icon="analysis" color="teal" background="true"></hvh-icon>
          <div>
            <div>
              <h1 class="hvh-h1">{{ cohort.name }}</h1>
            </div>
            <div>
              <p component="p" class="subheading">{{ cohort.description }}</p>
            </div>
            <div>
              <p class="subheading">{{ cohortTags }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template slot="content">
      <div class="hvh-dl hvh-dl--inline" style="overflow: hidden">
        <div v-if="cohort.cohortStatistic && selectedCohortStatus == 'Done'">
          <dt>Total Patients</dt>
          <dd>{{ customNumberFormat(cohort.cohortStatistic.totalCount) }}</dd>
        </div>
        <div>
          <dt>Data Source</dt>
          <dd>{{ cohort.patientDatasource }}</dd>
        </div>
        <div>
          <dt>Last Updated</dt>
          <dd v-if="cohort.creationDate">{{ browserDateTime(cohort.creationDate) }}</dd>
          <dd v-else>-</dd>
        </div>
        <div v-if="selectedCohortStatus == 'Done'">
          <dt>Patient Data As Of</dt>
          <dd v-if="cohort.datasetVersionLatestDate">{{ browserDateTime(datasetDate, 'MM/YYYY') }}</dd>
          <dd v-else>-</dd>
        </div>
        <div>
          <dt>Creator</dt>
          <dd style="max-width: 150px">{{ cohort.createdBy }}</dd>
        </div>
      </div>
    </template>
  </hvh-content-header>
</template>

<script>
import moment from 'moment';
import { customNumberFormat } from '../../libraries/common';
export default {
  props: ['cohort'],
  computed: {
    cohortTags() {
      return (this.cohort.tags || [])
        .map(f => f.startsWith("#") ? f : "#" + f)
        .join(' ');
    },
    isPopulationSegmentSelected() {
      return (self.data.selectedStatisticId != 0);
    },
    selectedCohortStatus() {
      return this.cohort.creationStatus;
    },
    datasetDate() {
      return moment(this.cohort.datasetVersionLatestDate).format('MM/DD/YYYY')
    },
  },
  methods: {
    customNumberFormat,
  },
}
</script>